<template>
    <v-container>
        <!-- 明細画面（月） -->
        <!-- <v-dialog v-model="dialog" max-width="1000" ref="dialog">-->
      <v-form ref="tableForm" v-model="tForm" lazy-validation>
        <template v-if="!tabletFlg">
          <v-card :disabled="false" v-if="!loadFlag" max-width="1000">
            <v-card-title>
              寮生情報
              <v-col cols="2" style="padding-top: 15px" class="no-print-area">
                <ryou-black-btn :small="true" style="background-color:black" :label="'<前月分'" :handlerClick="prevMonth">
                </ryou-black-btn>
                <ryou-black-btn :small="true" style="background-color:black" :label="'次月分>'" :handlerClick="nextMonth" :disabled="nextButtonDisable">
                </ryou-black-btn>
              </v-col>
              <v-col cols="3" style="padding-top: 15px" class="no-print-area">
                <ryou-black-btn :small="true" v-if="kanriFlg" style="background-color:black" :label="'6か月分表示'" :handlerClick="history" :disabled="multipleMonth">
                </ryou-black-btn>
                <ryou-black-btn :small="true" v-if="kanriFlg" style="background-color:black" :label="'一覧に戻る'" :handlerClick="handleCancel">
                </ryou-black-btn>
                <ryou-black-btn :small="true" v-if="kanriFlg" style="background-color:black" :label="'印刷'" :handlerClick="printPage" :iconCls="'mdi-printer'">
                </ryou-black-btn>
              </v-col>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">会社名</v-col>
                  <v-col cols="2" class="row_style">{{company_name}}</v-col>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">所属</v-col>
                  <v-col cols="6" class="row_style">{{affiliation}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">物件名</v-col>
                  <v-col cols="2" class="row_style">{{building_name}}</v-col>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">部屋番号</v-col>
                  <v-col cols="2" class="row_style">{{room_id}}</v-col>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">寮生区分</v-col>
                  <v-col cols="2" class="row_style">{{dormitory_student_name}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">ユーザID</v-col>
                  <v-col cols="2" class="row_style">{{user_id}}</v-col>
                  <v-col cols="2" class="row_style" style="background-color: #64B5F6;">ユーザ名</v-col>
                  <v-col cols="6" class="row_style">{{user_name}}</v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="tabletFlg">
          <v-card :disabled="false" v-if="!loadFlag" max-width="600">
            <v-card-title>
              {{billingMonth}}<br>({{dataRange}}実績)<br>請求情報
              <v-col cols="12" style="padding-top: 15px" class="no-print-area">
                <ryou-black-btn :small="true" style="background-color:black" :label="'<前月分'" :handlerClick="prevMonth">
                </ryou-black-btn>
                <ryou-black-btn :small="true" style="background-color:black" :label="'次月分>'" :handlerClick="nextMonth" :disabled="nextButtonDisable">
                </ryou-black-btn>
              </v-col>
            </v-card-title>
          </v-card>
        </template>
          <UserSalaryDeducationIndividual ref="modalForm" lazy-validation :loadFlag="loadFlag" @ok="modalFormOk">
          </UserSalaryDeducationIndividual>
          <!-- </v-dialog>-->
      </v-form>
    </v-container>
</template>

<script>
  import UserSalaryDeducationIndividual from "@/views/user/UserSalaryDeducationIndividual.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import { RyouTableMixins } from "@/mixins/RyouTableMixins";
  export default {
    name: "ClaimDetailDialog",
    mixins: [RyouTableMixins],
    components: {
      UserSalaryDeducationIndividual,
      RyouBlackBtn,
    },
    data: () => ({
      tForm: true,
      company_name: "",
      affiliation: "",
      building_name: "",
      room_id: "",
      dormitory_student_name: "",
      user_id: "",
      user_name: "",
      billingMonth: "",
      nextButtonDisable: false,
      multipleMonth: false,
      userClass: "",
      kanriFlg: false,
      tabletFlg: false,
      dataRange:"",
    }),
    props: {
      loadFlag: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    created() {
      this.machineModelCheck();
      this.init();
    },
    methods: {
      machineModelCheck() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        if (flag === null || flag === undefined || flag === "") {
          this.tabletFlg = false;
        } else {
          this.tabletFlg = true;
        }
      },
      handleCancel() {
        window.close();
      },
      modalFormOk() {
        this.$emit("closeDialog");
        this.handleCancel();
      },
      async init() {
          this.userClass = this.$store.getters.getUserClass
          // 寮生の場合
          if (this.userClass == "3") {
            const flg = await this.setItem();
            if (!flg) return              
          } else {
              this.kanriFlg = true
              this.paramSetItem();
          }
          this.open();

    },

      close() {
        // this.dialog = false;
      },
       async setItem() {
         let params = {
            userId: String(this.$store.getters.getUserId),
            userClass: String(this.$store.getters.getUserClass),
          };
          return await this.getRequest("/salaryDeductionInformation/userGet", params, this.$store.getters.getUserToken).then((data) => {
              // 利用者情報取得
              if (data.success) {
                  //ユーザ情報、ユーザ紐づけ情報
                  this.user_id = data.result.user_id;
                  this.company_name = data.result.company_name;
                  this.affiliation = data.result.affiliation;
                  this.building_name = data.result.building_name;
                  this.room_id = data.result.room_id;
                  this.dormitory_student_name = data.result.dormitory_student_name;
                  this.user_name = data.result.user_name;
                  this.billing_month = data.result.billing_month;
                  this.building_id = data.result.building_id;
                  this.billingMonth = this.billing_month.substr(0,4) + "年" + this.billing_month.substr(5,2) + "月";
                  this.dataRange = this.getArchiveDataRange(this.billing_month.substr(0, 4),this.billing_month.substr(5, 2) );
                  return true
                } else {
                  return false
                }
            });
        },
        paramSetItem() {
            // それ以外
            this.company_name = this.$route.query.company_name;
            this.affiliation = this.$route.query.affiliation;
            this.building_name = this.$route.query.building_name;
            this.room_id = this.$route.query.room_id;
            this.dormitory_student_name = this.$route.query.dormitory_student_name;
            this.user_id = this.$route.query.user_id;
            this.user_name = this.$route.query.user_name;
            this.billing_month = this.$route.query.billing_month;
            this.building_id = this.$route.query.building_id;
        },
        open() {
            let item = {
                user_id: this.user_id,
                user_name: this.user_name,
                user_name_kana: this.user_name_kana,
                company_name: this.company_name,
                affiliation: this.affiliation,
                building_id: this.building_id,
                room_id: this.room_id,
                billing_month: this.billing_month
            }

            setTimeout(() => {
                this.$refs.modalForm.setShowFlg(this.tabletFlg)
                this.$refs.modalForm.setUserData(item)
            }, 10);
            let timelist = this.billing_month.split("/");
            let Year = Number(timelist[0]);
            let Month = Number(timelist[1]);

            let checkParam = {
                Year: Year,
                Month: Month
            };
            this.checkNextButton(checkParam);

            this.multipleMonth = false;

        },
      prevMonth() {
        let timelist = this.billing_month.split("/");

        let targetYear = Number(timelist[1]) - 1 <= 0 ? Number(timelist[0]) - 1 : Number(timelist[0]);
        let Month = Number(timelist[1]) - 1 <= 0 ? 12 : Number(timelist[1]) - 1;
        let targetMonth = Month < 10 ? "0" + Month.toString() : Month.toString();
        let Day = Number(timelist[2]);
        let targetDay = Day < 10 ? "0" + Day.toString() : Day.toString();

        let target = targetYear.toString() + "/" + targetMonth.toString() + "/" + targetDay.toString();
        this.billing_month = target;
        this.billingMonth = this.billing_month.substr(0, 4) + "年" + this.billing_month.substr(5, 2) + "月";
        this.dataRange = this.getArchiveDataRange(this.billing_month.substr(0, 4),this.billing_month.substr(5, 2) );

        let param = {
          billing_month: target,
          multipleMonth: this.multipleMonth
        };
        setTimeout(() => {
          this.$refs.modalForm.prevMonth(param)
        }, 10);

        let checkParam = {
          Year: targetYear,
          Month: Month
        };
        this.checkNextButton(checkParam);

      },
      nextMonth() {
        let timelist = this.billing_month.split("/");

        let targetYear = Number(timelist[1]) + 1 >= 13 ? Number(timelist[0]) + 1 : Number(timelist[0]);
        let Month = Number(timelist[1]) + 1 >= 13 ? 1 : Number(timelist[1]) + 1;
        let targetMonth = Month < 10 ? "0" + Month.toString() : Month.toString();
        let Day = Number(timelist[2]);
        let targetDay = Day < 10 ? "0" + Day.toString() : Day.toString();

        let target = targetYear.toString() + "/" + targetMonth.toString() + "/" + targetDay.toString();
        this.billing_month = target;
        this.billingMonth = this.billing_month.substr(0, 4) + "年" + this.billing_month.substr(5, 2) + "月";
        this.dataRange = this.getArchiveDataRange(this.billing_month.substr(0, 4),this.billing_month.substr(5, 2) );
        let param = {
          billing_month: target,
          multipleMonth: this.multipleMonth
        };
        setTimeout(() => {
          this.$refs.modalForm.nextMonth(param)
        }, 10);

        let checkParam = {
          Year: targetYear,
          Month: Month
        };
        this.checkNextButton(checkParam);
      },
      history() {

        this.multipleMonth = true;
        let param = {
          billing_month: this.billing_month,
          multipleMonth: this.multipleMonth
        };
        setTimeout(() => {
          this.$refs.modalForm.history(param)
        }, 10);
      },
      checkNextButton(item) {
        let Year = item.Year;
        let Month = item.Month;

        let nowYear = new Date().getFullYear();
        let nowMonth = new Date().getMonth() + 1;
        let limitMonth = nowMonth + 2 <= 12 ? nowMonth + 2 : nowMonth + 2 - 12;
        let limitYear = nowMonth + 2 <= 12 ? nowYear : nowYear + 1;
        if (Year > limitYear) {
          this.nextButtonDisable = true;
        }
        else if (Year == limitYear && Month >= limitMonth) {
          this.nextButtonDisable = true;
        }
        else {
          this.nextButtonDisable = false;
        }
      },
      //印刷
      printPage() {
          window.print();
      },
      //月次処理実績年月日表示
    getArchiveDataRange(vYear,vMonth){
      
      // 引数の年と月を整数に変換
      var year = parseInt(vYear);
      var month = parseInt(vMonth);
      // 締め開始日
      var day = 1;

      var archiveYear = year;
      var archiveMonth = month - 1; 
      if(archiveMonth == 0){
        archiveYear = archiveYear - 1;
        archiveMonth = 12;
      }

      const firstDate = new Date(archiveYear,archiveMonth - 1, day).toLocaleDateString();
      const lastDate = new Date(archiveYear,archiveMonth, day - 1).toLocaleDateString();

      return firstDate + "～"+ lastDate;

    }
    },
  };
</script>
<style scoped>
  .rowBtn {
    width: 99%;
    padding-bottom: 20px;
  }
    .blackBtn {
        background-color: black;
    }
    .table_style {
        border-collapse: separate;
        width: 40%;
        text-align: left;
    }

  .table_style td, th {
    padding: 1px;
    font-size: 12px;
  }

  @media print {
    .no-print-area {
      display: none;
    }
  }
  .row_style {
    border: 1px solid;
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>